// 公共组件库远程加载配置
import { defineAsyncComponent, h } from 'vue';

// const COMPONENT_SERVER = 'http://47.98.186.79:6420';// 远程组件服务器地址-测试环境
const COMPONENT_SERVER = 'https://layout.hbzsb.cn';// 远程组件服务器地址-生产环境
const USE_REMOTE_COMPONENTS = true; // 切换远程组件加载

// 远程组件加载Promise
let loadPromise = null;

function loadRemoteComponents() {
  if (loadPromise) return loadPromise;
  
  loadPromise = new Promise((resolve, reject) => {
    const timestamp = Date.now(); // 添加时间戳避免缓存
    
    // 加载CSS
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = `${COMPONENT_SERVER}/layout-components.css?v=${timestamp}`;
    document.head.appendChild(link);
    
    // 加载UMD脚本
    const script = document.createElement('script');
    script.src = `${COMPONENT_SERVER}/layout-components.umd.js?v=${timestamp}`;
    script.onload = () => {
      if (window.LayoutComponents) {
        console.log('✅ 远程组件加载成功');
        resolve(window.LayoutComponents);
      } else {
        reject(new Error('LayoutComponents未挂载'));
      }
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
  
  return loadPromise;
}

// 创建异步组件包装器
function createRemoteComponent(componentName) {
  return defineAsyncComponent({
    loader: async () => {
      try {
        const remote = await loadRemoteComponents();
        console.log(`✅ ${componentName} 远程组件就绪`);
        return remote[componentName];
      } catch (error) {
        console.error(`❌ ${componentName} 远程加载失败，使用本地:`, error);
        const local = await import(`../views/layout/src/${componentName}.vue`);
        return local.default;
      }
    },
    delay: 0,
    timeout: 10000
  });
}

// 组件导出
export const Header = USE_REMOTE_COMPONENTS 
  ? createRemoteComponent('Header')
  : defineAsyncComponent(() => import('../views/layout/src/Header.vue'));

export const SideBar = USE_REMOTE_COMPONENTS
  ? createRemoteComponent('SideBar')
  : defineAsyncComponent(() => import('../views/layout/src/SideBar.vue'));
